import React from 'react';
import SelectFieldCheckbox from './SelectFieldCheckbox';
import ErrorMessage from '../../../ErrorMessage';
import OfficeService from '../../../../Services/OfficeService';

export default class PaymentOfficeSelect extends React.Component {
  static defaultProps = {
    value: null,
    className: 'w-100 form-control form-control-sm',
    filterCleared: false,
    fieldName: 'defaultFieldname',
    onChange: () => {},
    changeOfEditedMultipItem: () => {},
    IsCheckBoxEnabled: false,
    editedItem: {},
    idFilter: null,
  };

  constructor(props) {
    super(props);
    this.state = {
      selectValues: [],
    };
  }

  componentDidMount() {
    this.populateListData();
  }

  componentDidUpdate(prevProps) {
    if (this.props.idFilter !== prevProps.idFilter) {
      this.populateListData();
    }
  }

  populateListData() {
    if (!this.props.idFilter) return this.setState({ selectValues: [] });

    OfficeService.GetPaymentOffices(this.props.idFilter)
      .then((result) => {
        const optValues = [{ label: 'Choose one...', value: '', disabled: false }];
        result.forEach((office) => {
          optValues.push({ label: office.name, value: office.id, disabled: false });
        });
        this.setState({ selectValues: optValues });
      })
      .catch(() => {
        this.setState({ selectValues: [] });
        ErrorMessage.SetErrorMessage('POS41');
      });
  }

  render() {
    return (
      <SelectFieldCheckbox
        value={this.props.value}
        className={this.props.className}
        fieldName={this.props.fieldName}
        onChange={this.props.onChange}
        filterCleared={this.props.filterCleared}
        IsCheckBoxEnabled={this.props.IsCheckBoxEnabled}
        changeOfEditedMultipItem={this.props.changeOfEditedMultipItem}
        selectValues={this.state.selectValues}
        editedItem={this.props.editedItem}
      />
    );
  }
}
